"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompetitionInfoResponseToJSON = exports.GetCompetitionInfoResponseFromJSONTyped = exports.GetCompetitionInfoResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetCompetitionInfoResponseFromJSON(json) {
    return GetCompetitionInfoResponseFromJSONTyped(json, false);
}
exports.GetCompetitionInfoResponseFromJSON = GetCompetitionInfoResponseFromJSON;
function GetCompetitionInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currentCompetition': !(0, runtime_1.exists)(json, 'currentCompetition') ? undefined : (0, _1.SponsoredGuildCompetitionFromJSON)(json['currentCompetition']),
        'lastCompetition': !(0, runtime_1.exists)(json, 'lastCompetition') ? undefined : (0, _1.SponsoredGuildCompetitionWithWinnersFromJSON)(json['lastCompetition']),
    };
}
exports.GetCompetitionInfoResponseFromJSONTyped = GetCompetitionInfoResponseFromJSONTyped;
function GetCompetitionInfoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currentCompetition': (0, _1.SponsoredGuildCompetitionToJSON)(value.currentCompetition),
        'lastCompetition': (0, _1.SponsoredGuildCompetitionWithWinnersToJSON)(value.lastCompetition),
    };
}
exports.GetCompetitionInfoResponseToJSON = GetCompetitionInfoResponseToJSON;
